import { render, staticRenderFns } from "./planning_alerts_wrapper.vue?vue&type=template&id=803686a8&"
import script from "./planning_alerts_wrapper.vue?vue&type=script&lang=js&"
export * from "./planning_alerts_wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports